import QuestionsSection from "./sections/QuestionsSection";
import SurveyInfoSection from "./sections/SurveyInfoSection";
import TopImageSection from "./sections/TopImageSection";
import UserInfoSection from "./sections/UserInfoSection";
import { Container } from "./styles";

export default function SurveyEditor({ values = {}, onChangeValue = () => null }) {
  return (
    <Container>
      <TopImageSection values={values} onChangeValue={onChangeValue} />
      <SurveyInfoSection values={values} onChangeValue={onChangeValue} />
      <UserInfoSection values={values} onChangeValue={onChangeValue} />
      <QuestionsSection values={values} onChangeValue={onChangeValue} />
    </Container>
  );
}